// @givmo/board — factual provenance label for Connected-AI working drafts.
//
// `draft_origin` is additive on the backend proposal slice but is not in this branch's committed
// OpenAPI snapshot yet. Read it narrowly from `unknown` until a routine post-merge snapshot refresh
// absorbs the field. Missing, malformed, `human`, and unknown future values all mean NO label: this
// surface reports provenance only when the wire says exactly `connected_ai`, and never guesses.

import { Badge } from '@givmo/design-system';

export interface ConnectedAiDraftBadgeProps {
  /** The agenda item or consent-version object whose additive provenance field is being read. */
  readonly source: unknown;
  readonly testId: string;
}

export function isConnectedAiDraft(source: unknown): boolean {
  if (typeof source !== 'object' || source === null) return false;
  return (source as Record<string, unknown>).draft_origin === 'connected_ai';
}

export function ConnectedAiDraftBadge({ source, testId }: ConnectedAiDraftBadgeProps) {
  if (!isConnectedAiDraft(source)) return null;

  return (
    <Badge tone="neutral" testId={testId}>
      Connected-AI draft
    </Badge>
  );
}
